<app-view-item *ngIf="readonly" [text]="selected?.code" [borderless]="borderless"></app-view-item>
<nz-select
  *ngIf="!readonly"
  #selector
  nzShowSearch
  nzServerSearch
  [nzBackdrop]="addBackdrop"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event, 50)"
  (nzOpenChange)="handleOpenChange($event)"
  (nzScrollToBottom)="loadMore()"
  (keydown)="handleKeyDown($event)"
  (click)="handleClick($event)"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzDisabled]="disabled"
  [nzBorderless]="borderless"
  nzDropdownClassName="dropdownSelect"
  [nzDropdownRender]="renderTemplate"
  class="width-100"
  [nzPlacement]="dropdownPlacement"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>

  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
      <div>
        <strong>{{ o.code }}</strong>
      </div>
      <div class="text-grey-dark">
        {{ o.description }}
      </div>
      <div class="text-grey-dark">
        {{ o.rate | currency: ' ' }}
      </div>
    </nz-option>
  </ng-container>
</nz-select>

<ng-template #renderTemplate>
  <div class="text-center">
    <button type="button" nz-button nzType="primary" (click)="addNew()">
      <span nz-icon nzType="plus"></span>
      {{ instantData ? ' Add New \''+ instantData +'\'' : ' Add New' }}
    </button>
  </div>
</ng-template>
